/**
 * HTML 安全过滤模块
 * 使用 DOMPurify 统一过滤危险标签与属性
 */

import DOMPurify from 'isomorphic-dompurify'

const DOMPURIFY_CONFIG = {
  ADD_TAGS: ['message', 'narration'],
  FORBID_TAGS: ['base'],
}

/**
 * 过滤 HTML 中的危险内容
 * @param html 原始 HTML
 * @returns 安全的 HTML
 */
export function sanitizeHtml(html: string): string {
  if (!html) return ''
  return DOMPurify.sanitize(html, DOMPURIFY_CONFIG) as string
}
